module.exports = __webpack_public_path__ + "img/employees.f89cc501.svg";